import React from 'react';
import { Modal, Typography, Avatar } from 'antd';
import type { EncounterResult } from '../../types/types';

const { Title, Text } = Typography;

interface EncounterModalProps {
  isOpen: boolean;
  onClose: () => void;
  result: EncounterResult | null;
}

const EncounterModal: React.FC<EncounterModalProps> = ({ isOpen, onClose, result }) => {
  return (
    <Modal
      title="Random Encounter!"
      open={isOpen}
      onCancel={onClose}
      footer={null}
    >
      {result ? (
        <div style={{ textAlign: 'center' }}>
          <Avatar src={result.image} size={64} style={{ marginBottom: '1rem' }}>{result.name.charAt(0)}</Avatar>
          <Title level={4}>{result.quantity}x {result.name}</Title>
          <Text>... appears!</Text>
        </div>
      ) : (
        <Text>No encounter this time. The path is clear... for now.</Text>
      )}
    </Modal>
  );
};

export default EncounterModal;